var _a, _b;
import { AppType } from '@wix/adi-core-types';
import { isAppWidgetType } from '../types/content';
export var RecommendedAppByStructure = (_a = {},
    _a[AppType.PaidPlans] = new Set([
        'c198cf0a69f990711dedbb72',
        '8ccc686ed6279ed5b30503c4',
        'a64a4321b4484599dd41fe3d',
        'cd56860bcbe70d98fcfb09a0',
        '5115f39a3c9dc70bdce69b77',
        '89fa91123688531f0a4ba0ce',
        '5df51a2bdce21148ecd41472',
        '5fb61ada96417edd325f09eb',
        '1be1cd28dd126c4e7e3f6cc4',
        '714a7d52812e0df69b1634a3',
        'd52c7057b8f5038522203aaf',
        '776a85cee8c21539cf915916',
        '55d4e81833bc9eada9dffd0c',
        '9d7a187691adf3ea2fefbf80',
        '5bfd52ae0261ae001af5ae3c',
        'dfbbb078a5a20019a393bcf6',
        '7e5b50a94082f1476c1683ee',
        '3b0c5d7beaa4220e2a870058',
        'bb605aa1b1a1e21608c1aa50',
        '09e33ad16c590a079d737a41',
        'ff9d59c82e78e4910bf642d7',
        '1265240190ad56db08acdf09',
        '3bb14e66865a11fd85762592',
        'f47645a3efc7cc2810974e4b',
        '844f6823d299303fcf521e3c',
    ]),
    _a);
export var PreferredAppByStructure = (_b = {},
    _b[AppType.PhotoAlbums] = new Set([
        '88337e3560e889b475d492a7',
        'b5ab898f0afbfec00845808e',
        '4c41f36c745880e6e42c5838',
        'c280f2565940817f4edc48fe',
        '54004a861a39c4a3eb57d114',
        'f1b75b7b719f5ed5b5bdc41f',
        'c5c1f3c63915119ed5c7feff',
        'be6f1d8dc988d56f886ed440',
        '7d9f2f2d93d10adfb06b97f8',
        '87de0335f09ebc252139974c',
        '320bc14e388b60c6ab499242',
        'cba925039ed9d3d360590d31',
        '02b40f8270007a792c300561',
        '70d8036f281d1ce612272b6a',
        'afee35922f1083c84a62b114',
        '9b888a944e35417b0916e075',
        '228113fd238f42db1cf7160a',
        '3278ba04c3340b40d058ed5f',
        'f764b4a56aca6b9f42c3ec3a',
        '94d4b55ce16bd162b833e148',
        '481a36b3eeb98dbfc2f904a6',
        'fa28a6f03dbe530a8a8c6fcc',
        '6faf46a50ee4aa0fff4e1135',
        '137221e480f86fbd3c80436a',
        '0f04c68cffed335f82caabfa',
        'fc57b1629c4ff302fb03e79c',
        '0fdf8f7c1fd0fb710ecb8826',
    ]),
    _b);
export var widgetToAppMap = new Map([
    ['BandsInTown_Widget', AppType.BandsInTown],
    ['Blog_Single_Post_Widget', AppType.Blog],
    ['Blog_Post_Gallery', AppType.Blog],
    ['Blog2_Custom_Feed_Widget', AppType.Blog],
    ['Blog2_Post', AppType.Blog],
    ['Bookings_Widget', AppType.Bookings],
    ['Bookings', AppType.Bookings],
    ['Chat_Widget', AppType.Chat],
    ['Events', AppType.Events],
    ['Events_Single', AppType.Events],
    ['Events_Multiple', AppType.Events],
    ['Events_Schedule', AppType.Events],
    ['GetSubscribers_Widget', AppType.GetSubscribers],
    ['Hotels_Search_Bar_Widget', AppType.Hotels],
    ['Instagram_Widget', AppType.Instagram],
    ['Music_Widget', AppType.Music],
    ['ProGallery_Widget', AppType.ProGallery],
    ['Stores_Product_Widget', AppType.Stores],
    ['Stores_Grid_Gallery_Widget', AppType.Stores],
    ['Stores_Slider_Gallery_Widget', AppType.Stores],
    ['Stores_Thank_You_Widget', AppType.Stores],
    ['Stores_Shopping_Cart_Widget', AppType.Stores],
    ['Stores_Product_specific_Widget', AppType.Stores],
    ['Video_Widget', AppType.Video],
    ['RestaurantsReservations_Widget', AppType.RestaurantsReservations],
    ['Challenges_SingleChallenge', AppType.Challenges],
    ['Groups_SingleGroup', AppType.Groups],
]);
export var EventSingleStructures = new Set([
    '86614cf07e4b4b958c17799e',
    '53ccd6d3ed28056652523bf8',
    '4115b4b3648e14a3d30fc868',
    'd0a23df9f1f222e74ee14792',
    '8ad09c40cd032d6f157c3061',
    '8f92fe0b3e5ac39b968ed30a',
    '66ab3cd9ab82187cba6d438a',
    '3118118a1e2e5ef4539a51f3',
    '64019cca29a74c24d67ceb8e',
    '2634908fb29b65cc063198ae',
    '59922f2d4d214b6def6bdb1c',
    '93762d8e11ff81ded43e0d01',
    'a1b4f8164a1a626a7eab7242',
    '2b2732a277096b81176a53e0',
    '039e2da6322d72456c116493',
    '2597ed3258e7803bf2df1d3a',
    'befcaf30ac3c975eff7c8018',
    '9f963f4ae9923320f3d0df74',
    'd24103ac38dad574c915c6d4',
    '6366bb29a125a48254d64d8f',
    'c3315453c35066966a2a2b6e',
    '3edc74db8e5c9df30f410797',
    'ff34af892529b6245eee17ef',
    '1ab0758e82c7e024d6bc00fb',
    '82e7dd0419f621c370d802cd',
    '2ccd9638ebbeffef7087609f',
    '96752dbe194b85d9648d5b49',
    '661faae4694aff347897a3c6',
    '72e1e5106f07cecc6118594d',
    'd92c36de57e30d8ba567d7de',
    '5ebd5133b989ad0017a18d9a',
    '54fb3d4c6778370d1f891ab8',
    'b22365fd4a66364e95602d70',
    '7f46632f92b9f8f5c1afa658',
    '5bc45e059dd89e0014102a50',
    '5ef99cac71ae2c001796e89f',
    '77cb9f8b7e6e46e77384199b',
]);
export var PhotographerStructures = new Set([
    'fa28a6f03dbe530a8a8c6fcc',
    'c280f2565940817f4edc48fe',
    '70d8036f281d1ce612272b6a',
    'cba925039ed9d3d360590d31',
    'f1b75b7b719f5ed5b5bdc41f',
    'fc57b1629c4ff302fb03e79c',
    '228113fd238f42db1cf7160a',
    'c5c1f3c63915119ed5c7feff',
    '4c41f36c745880e6e42c5838',
    'b5ab898f0afbfec00845808e',
    '54004a861a39c4a3eb57d114',
    '6faf46a50ee4aa0fff4e1135',
    '02b40f8270007a792c300561',
    '481a36b3eeb98dbfc2f904a6',
    '94d4b55ce16bd162b833e148',
    '88337e3560e889b475d492a7',
    '0f04c68cffed335f82caabfa',
    '3278ba04c3340b40d058ed5f',
    'f764b4a56aca6b9f42c3ec3a',
    '0fdf8f7c1fd0fb710ecb8826',
    '320bc14e388b60c6ab499242',
    '9b888a944e35417b0916e075',
    'be6f1d8dc988d56f886ed440',
    '137221e480f86fbd3c80436a',
    'afee35922f1083c84a62b114',
    '87de0335f09ebc252139974c',
    '7d9f2f2d93d10adfb06b97f8',
    '0d9c96444715ddf86b7dae9c',
]);
export var StoresStructures = new Set([
    '073bd83d054dcff87fa0ef50',
    'a86dc9747f3eede342189f83',
    'e6bd3dc3eea5928b0ea7fd47',
    'dddf5389b593c624fe904f35',
    '3ca1657afcf3c6962bd3850c',
    '34ffe449f805db7d9bb44c51',
    'f07829409b6a57fced0e0e13',
    '920d6d4e861dfb385da1016c',
    '2641c344379a9aaa8eaab7b2',
    'ff00aaba40bcd8404c7c15c2',
    'bb605aa1b1a1e21608c1aa50',
    '61291f908427a61d9cee17e2',
    '503eb1485f6d9be61cd7440e',
    '55ac5d9bf289db056e9ca2df',
    '5d50eae4431c5f001609546c',
    '5d4c1ef4ec51d2001661f45f',
    '5e8b0b06b997ac001740fa21',
    '5ec23de43a635c0017d53ae9',
    '5ea7f08ced4e97001721da5d',
    '5bc6cb099dd89e0014103472',
    '600952e543af240017d5594c',
    '602a2b00a82f330017e684d0',
    '60b493de5495c60015068add',
    '60c0d7db9d0f3100159bbe6b',
    '602e58aca82f330017e688f8',
    '363531a28861adcbe9be3cf5',
    '5e8990a1a1839b00178997a5',
    '77579abf69b1c6bd6726be48',
    '08315294c271eec98e3b1f41',
    '76746b93113b9a86b26edbd3',
    'a66f145339745ae5b5d62d33',
    '5344b9f2a0058d3be498d9d4',
    '0bc120ad2fe7e18f6cf0c8f3',
    'e1a2f009d01ba711cb49a6cb',
    '7fa9b9d0c589fb130a92a894',
    'fdb83cb137cb4ce03bd8d6f6',
    '41d91b03c3189cf19af970e9',
    '78ca987ffcc56b3700ad1c4f',
    '431720e6e1e65930d6bbbcc3',
    'ce60cecd67422e0eef44b7df',
    '27388b92e83f3e062c9a5a57',
    '73047226bf3c3a5838618cdf',
    'fe2330231227b5623bae10bd',
    'fba0772e6230b75df865dbdc',
    'e6a70a5eb742350b0e357819',
    'a82c47ec07116f80d61defc2',
    '654f7124a6922f34e284a943',
    '26797e2a402eceb6ed2dd055',
    '49d4118fe9dc7312ae1cc1fc',
    '3142071cfdc0d18b30881539',
    '60ebede65ac6740015c8bb0a',
    '61ffb556c2dc7c0016f57982',
    '621491928d53310016a87e8b',
    'ff8e8c36452f407f5c87c455',
    '62b9813aa2fecd001e4157e5',
]);
export var BlogStructures = new Set([
    '641c03de0e98480012086c24',
    'b0a520919b99728bae200018',
    '1a807ebfa9792fc45bfe845e',
    '60ebe220e0aacf0015cecf8c',
    '6107f122eec48300158889ec',
    '611507cbcb41440015253611',
    '613efcf07b3e9c0016571b2a',
    '6140a65e7d886100167a7fb5',
    '61712509276d2b00161abefd',
    '6190c09ea9d7560016809730',
    '61a884000d569e0016fd1b6b',
    '61c464e016d3210017c9950b',
    '61fffa7a37e74f001668d7c0',
    '6200c63137e74f001668d820',
    '6211dd7882ec780018eed6b5',
]);
export function getAppTypeByWidgetType(type) {
    if (isAppWidgetType(type)) {
        return widgetToAppMap.get(type);
    }
    return type;
}
//# sourceMappingURL=constants.js.map